import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { DoorOpen, BookOpen, UserSearch, MapPin } from "lucide-react";
import { GateAttendanceReport } from "./GateAttendanceReport";
import { SessionAttendanceReport } from "./SessionAttendanceReport";
import { StudentAttendanceReport } from "./StudentAttendanceReport";
import { TuitionReports } from "./tuition/TuitionReports";

export function AttendanceReports() {
  return (
    <Tabs defaultValue="gate" className="space-y-4">
      <TabsList>
        <TabsTrigger value="gate"><DoorOpen className="w-4 h-4 mr-1" /> Main Gate</TabsTrigger>
        <TabsTrigger value="session"><BookOpen className="w-4 h-4 mr-1" /> Session-Based</TabsTrigger>
        <TabsTrigger value="rotation"><MapPin className="w-4 h-4 mr-1" /> Rotation</TabsTrigger>
        <TabsTrigger value="student"><UserSearch className="w-4 h-4 mr-1" /> Per-Student</TabsTrigger>
      </TabsList>
      <TabsContent value="gate"><GateAttendanceReport /></TabsContent>
      <TabsContent value="session"><SessionAttendanceReport /></TabsContent>
      <TabsContent value="rotation"><TuitionReports /></TabsContent>
      <TabsContent value="student"><StudentAttendanceReport /></TabsContent>
    </Tabs>
  );
}
